import { Box, Flex } from '@rebass/grid'
import * as moment from 'moment'
import * as React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'semantic-ui-react'
import Icon from 'src/components/Icon'
import { RWD } from 'src/elements/RWD'
import styled from 'styled-components'
import { Text } from '../../elements/Text'

const Container = styled.div`
  display: flex;
  height: 70px;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
  margin-bottom: 12px;
  padding: 20px;
  align-items: center;
  z-index: 1;
  border-radius: 4px;
  @media (max-width: 576px) {
    height: 62px;
    margin-bottom: 0px;
    border-radius: 4px 4px 0px 0px;
  }
`

const ButtonContainer = styled(Flex)`
  width: 80px;
  margin-right: 12px;
  align-items: center;
`
const TextContainer = styled.div`
  flex: 1;
`

const IntroContainer = styled.div`
  display: flex;
  align-items: center;
  justify-self: flex-end;
`

const LectureHeader = ({
  lectureId,
  lecture
}: {
    lectureId: string
    lecture: ILecture | null
  }) => (
    <Container>
      {lecture && new Date() >= lecture.startedAt.toDate() && new Date() <= lecture.endedAt.toDate() && (
        <ButtonContainer>
          <Button color="orange" size="mini" fluid={true}>
            <Box mr={1}>
              <Icon type="lecture-comment-w" size={16} />
            </Box>
            <Box>回覆中</Box>
          </Button>
        </ButtonContainer>
      )}
      <TextContainer>
        {lecture ? (
          new Date() > lecture.endedAt.toDate() ? (
            '目前講師無在線時段'
          ) : (
              <RWD.Default>
                {`講師回覆時段 ${moment(lecture.startedAt.toDate()).format(
                  'MM/DD'
                )} - ${moment(lecture.endedAt.toDate()).format('MM/DD')}`}
              </RWD.Default>
            )
        ) : null}
      </TextContainer>
      <Link to={`/lectures/${lectureId}`}>
        <IntroContainer>
          <Box mr={1}>
            <Icon type="introduce" size={20} />
          </Box>
          <Box>
            <Text.ContentGray>簡介</Text.ContentGray>
          </Box>
        </IntroContainer>
      </Link>
    </Container>
  )

export default LectureHeader



// WEBPACK FOOTER //
// ./src/pages/LectureContentPage/LectureHeader.tsx